import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  CreateEscritorioDto,
  EscritorioFilters,
  UpdateEscritorioDto,
} from '@/types/escritorio/escritorioCrudTypes';

import { escritorioService } from './services';

export const listarWorkspaces = createAsyncThunk(
  'escritorioCrud/listarWorkspaces',
  async (_: void | undefined, { rejectWithValue }) => {
    try {
      return await escritorioService.listarWorkspaces();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarWorkspacePessoal = createAsyncThunk(
  'escritorioCrud/buscarPessoal',
  async (_: void | undefined, { rejectWithValue }) => {
    try {
      return await escritorioService.buscarPessoal();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const listarEscritorios = createAsyncThunk(
  'escritorioCrud/listar',
  async (filters: EscritorioFilters | undefined, { rejectWithValue }) => {
    try {
      return await escritorioService.listar(filters);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarEscritorioPorId = createAsyncThunk(
  'escritorioCrud/buscarPorId',
  async (id: string, { rejectWithValue }) => {
    try {
      return await escritorioService.buscarPorId(id);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const criarEscritorio = createAsyncThunk(
  'escritorioCrud/criar',
  async (data: CreateEscritorioDto, { rejectWithValue }) => {
    try {
      return await escritorioService.criar(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const atualizarEscritorio = createAsyncThunk(
  'escritorioCrud/atualizar',
  async ({ id, data }: { id: string; data: UpdateEscritorioDto }, { rejectWithValue }) => {
    try {
      return await escritorioService.atualizar(id, data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const excluirEscritorio = createAsyncThunk(
  'escritorioCrud/excluir',
  async (id: string, { rejectWithValue }) => {
    try {
      await escritorioService.excluir(id);
      return id;
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const checkNomeEscritorio = createAsyncThunk(
  'escritorioCrud/checkNome',
  async (nome: string, { rejectWithValue }) => {
    try {
      return await escritorioService.checkNome(nome);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const checkSubdominioEscritorio = createAsyncThunk(
  'escritorioCrud/checkSubdominio',
  async (subdominio: string, { rejectWithValue }) => {
    try {
      return await escritorioService.checkSubdominio(subdominio);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const updateLastWorkspace = createAsyncThunk(
  'escritorioCrud/updateLastWorkspace',
  async ({ userId, workspaceId }: { userId: string; workspaceId: string }, { rejectWithValue }) => {
    try {
      return await escritorioService.updateLastWorkspace(userId, workspaceId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
